var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForceAssetStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.5C9.38069 7.5 10.5 6.38069 10.5 5C10.5 3.61929 9.38069 2.5 8 2.5C6.61929 2.5 5.5 3.61929 5.5 5C5.5 6.38069 6.61929 7.5 8 7.5Z",
    stroke: "#F22279",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 7.5C17.6046 7.5 18.5 6.60455 18.5 5.5C18.5 4.39543 17.6046 3.5 16.5 3.5C15.3954 3.5 14.5 4.39543 14.5 5.5C14.5 6.60455 15.3954 7.5 16.5 7.5Z",
    stroke: "#F22279",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 11.5C3.5 10.9477 3.94772 10.5 4.5 10.5H11.5C12.0523 10.5 12.5 10.9477 12.5 11.5V17C12.5 19.4853 10.4853 21.5 8 21.5V21.5C5.51472 21.5 3.5 19.4853 3.5 17V11.5Z",
    stroke: "#F22279",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6152 20.2746C14.4148 20.8865 15.4145 21.25 16.4991 21.25C19.1225 21.25 21.2491 19.1234 21.2491 16.5V11.4091C21.2491 10.4928 20.5063 9.75 19.5901 9.75H13.9361C14.2448 10.1791 14.4429 10.693 14.4889 11.25H19.5901C19.6779 11.25 19.7491 11.3212 19.7491 11.4091V16.5C19.7491 18.2949 18.2941 19.75 16.4991 19.75C15.6198 19.75 14.822 19.4008 14.237 18.8335C14.0876 19.3426 13.8775 19.8257 13.6152 20.2746Z",
    fill: "#F22279"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForceAssetStatus);
export default __webpack_public_path__ + "static/media/force-asset-status.1cc2714d3cd21994d7ae330806109c10.svg";
export { ForwardRef as ReactComponent };